"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_bullets_fill_style_1 = __importDefault(require("./uicon.bullets.fill.style"));
class UiconBulletsFill extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { d: "M28.952 0H3.048A3.048 3.048 0 000 3.048v25.904A3.048 3.048 0 003.048 32h25.904A3.048 3.048 0 0032 28.952V3.048A3.048 3.048 0 0028.952 0zM8.9 23.802H5.851V21.82H8.9v1.98zm0-6.872H5.851v-1.981H8.9v1.98zm0-6.751H5.851v-1.98H8.9v1.98zm17.22 13.623h-13.41V21.82h13.41v1.98zm0-6.872h-13.41v-1.981h13.41v1.98zm0-6.751h-13.41v-1.98h13.41v1.98z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconBulletsFill.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconBulletsFill.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_bullets_fill_style_1.default)(UiconBulletsFill);
//# sourceMappingURL=uicon.bullets.fill.js.map